<template>
    <div id="XferToSite" class='row'>
        <div class='col-12'>
            <TabNav :tabs="['To Bin/Location', 'To Site']" :selected="selected" @selected="setSelected" >
                <Tab :isSelected="selected === 'To Bin/Location'">

                    <ToBinLocation/>

                </Tab>
                <Tab :isSelected="selected === 'To Site'">

                    <ToSite/>

                </Tab>
            </TabNav>

            <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><!-- Temp -->
        </div>
    </div>
</template>

<script>
  import TabNav from '../../../common/TabNav'
  import Tab from '../../../common/Tab'
  import ToBinLocation from './Xfer/ToBinLocation'
  import ToSite from './Xfer/ToSite'

  export default {
    name : 'XferToSite',
    components: {
      TabNav,
      Tab,
      ToBinLocation,
      ToSite,
    },
    mounted() {
      this.isPowerScan = true;
    },
    data() {
      return {
        selected: 'To Bin/Location',
        isPowerScan: this.$store.getters['Navigation/isPowerScan'],
      }
    },
    methods : {
      setSelected(tab) {
        this.selected = tab;
      },
    }
  }
</script>
